import { processDataService } from '../../../services/processDataService'
import { ACTIVITY_TYPES, FIELD_TYPES, PROCESS_ACTIVITY_STATUSES } from '../../../utility/constants'

export const getFieldId = (id) => {
  return `f_${id}`
}

export const getTableRowId = (id) => {
  return `tr_${id}`
}

export const getTableFieldId = (id) => {
  return `tf_${id}`
}

export const getCommentId = (id) => {
  return `c_${id}`
}

export const getReviewId = (id) => {
  return `r_${id}`
}

export const getTableCommentId = (id, row) => {
  return `c_${id}__${row}`
}

export const getTableReviewId = (id, row) => {
  return `r_${id}__${row}`
}

export const getConstraintErrorId = (id) => {
  return `fce_${id}`
}

export const getConstraintErrorIdFromFieldId = (fieldId) => {
  return fieldId.replace('f_', 'fce_')
}

export const getConstraintErrorIdForColumn = (id, row) => {
  return `fce_${id}__${row}`
}

export const getIdFromFieldId = (fieldId) => {
  return fieldId.split('_')[1]
}

export const getRowFromRowId = (fieldId) => {
  return Number(fieldId.split('_')[1])
}

export const getLegacySubfieldId = (fieldId, row) => {
  return `f_${fieldId}__${row}`
}
export const getLegacySubfieldReviewId = (fieldId, row) => {
  return `r_${fieldId}__${row}`
}
export const getLegacySubfieldCommentId = (fieldId, row) => {
  return `c_${fieldId}__${row}`
}

export const getRowAndFieldFromLegacySubfieldId = (legacySubfieldId) => {
  let fieldId = legacySubfieldId.split('_')[1].split('__')[0]
  let row = legacySubfieldId.split('__')[1]
  return { fieldId, row }
}

export const getTableRowsId = (tableId) => {
  return `tf_${tableId}_rows`
}

export const getSelectableTableId = (tableId) => {
  return `st_${tableId}`
}

export const getFieldIdFromKey = (key = '') => {
  const afterPrefix = key.split('_').slice(1).join('_')

  if (afterPrefix.includes('__')) {
    const [id, row] = afterPrefix.split('__')
    return { id: Number(id), row }
  } else {
    return { id: Number(afterPrefix) }
  }
}

export const removeTableStructureData = (data = {}, allFields = []) => {
  const values = { ...data }
  const tableFieldIds = allFields
    .filter((it) => it.data_structure == FIELD_TYPES.TABLE)
    .map((it) => getTableFieldId(it.id))
  tableFieldIds.forEach((it) => {
    delete values[it]
  })
  return values
}

export const getColumnFilterId = (fieldId) => {
  return `fltr_${fieldId}`
}

export const getPageId = (pageId) => {
  return `p_${pageId}`
}

export const getDataAcrossProcess = async (user, processId, query = {}) => {
  const { data, ndc } = (
    await processDataService.getProcessDataExcludingRejectedByProcessTemplateId(
      user,
      processId,
      query
    )
  ).data

  let result = Object.values(
    data.reduce((acc, datum) => {
      if (acc['prn_' + datum.process_reference_num]) {
        acc['prn_' + datum.process_reference_num] = [
          ...acc['prn_' + datum.process_reference_num],
          datum,
        ]
      } else {
        acc['prn_' + datum.process_reference_num] = [datum]
      }
      return acc
    }, {})
  )

  result = result.map((data) => {
    return Object.values(
      data.reduce((acc, datum) => {
        if (
          !acc['act_' + datum.activity_template_id] ||
          acc['act_' + datum.activity_template_id].version < datum.version
        ) {
          acc['act_' + datum.activity_template_id] = datum
        }
        return acc
      }, {})
    )
  })

  result = result.map((datum) => {
    const combineData = datum?.reduce((acc, datum2) => {
      if (
        datum2.activity_type === ACTIVITY_TYPES.DATA_ENTRY &&
        datum2.status == PROCESS_ACTIVITY_STATUSES.CLOSED
      ) {
        acc = { ...acc, ...datum2.data }
      }
      return acc
    }, {})
    return {
      process_reference_num: datum[0].process_reference_num,
      data: combineData,
    }
  })

  return { data: result, ndc }
}

export const getKeyOfValue = (obj, keyValue) => {
  if (!keyValue) return null
  return Object.entries(obj).find(([_, value]) => value === keyValue)?.[0]
}
